import React from "react";
import { FacebookLogo, InstagramLogo, XLogo } from "@phosphor-icons/react";
const Social = ({ t }) => {
  return (
    <div className="flex items-center justify-center">
      <ul className="flex items-center justify-center gap-x-4 md:gap-x-6 lg:gap-x-8 mt-6">
        <li>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-primary transition-colors"
            aria-label={t("common.social.facebook", "Facebook")}
          >
            <FacebookLogo size={24} />
          </a>
        </li>
        <li>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-primary transition-colors"
            aria-label={t("common.social.instagram", "Instagram")}
          >
            <InstagramLogo size={24} />
          </a>
        </li>
        <li>
          <a
            href="https://x.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-primary transition-colors"
            aria-label={t("common.social.x", "X (Twitter)")}
          >
            <XLogo size={24} />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Social;
